import { Link } from "react-router-dom";
import { BookOpen } from "lucide-react";

/** Bölüm ekranlarından ilgili kullanım kılavuzuna götüren küçük düğme. */
export const GuideLink = ({ slug, label = "Nasıl kullanılır?", tone = "light" }) => (
  <Link to={slug ? `/kilavuz/${slug}` : "/kilavuz"} target="_blank" rel="noreferrer"
    data-testid={`guide-link-${slug || "all"}`}
    className={`inline-flex h-9 shrink-0 items-center gap-1.5 rounded-full px-4 text-xs font-bold transition-colors duration-150 ${
      tone === "dark"
        ? "border border-white/25 text-primary-foreground hover:bg-white/10"
        : "border border-border text-primary hover:bg-muted"}`}>
    <BookOpen className="h-3.5 w-3.5" /> {label}
  </Link>
);

export default GuideLink;
